import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosResponse } from "axios";
import { baseUrlApi } from "../../proxy";
import CAxios from "../utils/CAxios";

// to Add Sponsor
export const toAddSponsor = createAsyncThunk<AxiosResponse<any, any>, any>(
  "recipient/toAddSponsor",
  async (sponsor) => {
    const config = { headers: { "Content-Type": "application/json" } };
    return await axios.post(`${baseUrlApi}sponsor`, sponsor, config);
  }
);

// get contact methods
export const toGetAllContactMethods = createAsyncThunk<AxiosResponse<any, any>>(
  "recipient/getAllContactMethods",
  async () => {
    try {
      let response = await axios.get(`${baseUrlApi}contact/methods`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

// get contact time
export const toGetAllContactTime = createAsyncThunk<AxiosResponse<any, any>>(
  "recipient/toGetAllContactTime",
  async () => {
    try {
      let response = await axios.get(`${baseUrlApi}contact/times`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

// get banks
export const toGetAllBanks = createAsyncThunk<AxiosResponse<any, any>>(
  "recipient/toGetAllBanks",
  async () => {
    try {
      let response = await axios.get(`${baseUrlApi}banks`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
//GET Sponsor details
export const getSponsorDetails = createAsyncThunk<any, { sponsor_id: number }>(
  "sponsor/getSponsorDetails",
  async (payload) => {
    try {
      const response = await CAxios.post(`sponsor/details`, payload);
      return response?.data?.result;
    } catch (error) {
      throw error;
    }
  }
);

export const getSponsorReports = createAsyncThunk<
  any,
  { sponsor_id: number; limit?: number; page?: number }
>("sponsor/getSponsorReports", async (data) => {
  try {
    const response = await CAxios.post(`user/reports`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const getSponsorThanksCertificate = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("sponsor/getSponsorThanksCertificate", async (id) => {
  try {
    let response = await CAxios.get(`/sponsor/thanks/certificate/print/${id}`, {
      responseType: "blob" as const,
    });
    return response;
  } catch (error) {
    throw error;
  }
});

export const getDonationsDetails = createAsyncThunk<
  any,
  {
    sponsor_id: number;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("sponsor/getDonationsDetails", async (sponsor_id) => {
  try {
    let response = await CAxios.post(`donation/details`, sponsor_id);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const getPaymentDetails = createAsyncThunk<
  any,
  {
    sponsor_id: number;
    limit?: number;
    page?: number;
    date_from?: string;
    date_to?: string;
  }
>("sponsor/getPaymentDetails", async (data) => {
  try {
    let response = await CAxios.post(`payment/details`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const getSponsorDisbursements = createAsyncThunk<
  any,
  {
    sponsor_id: number;
    limit?: number;
    page?: number;
  }
>("sponsor/getSponsorDisbursements", async (data) => {
  try {
    let response = await CAxios.post(`sponsor/disbursements`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const getOldSystemPayments = async (data: { sponsor_id: number }) => {
  const response = await CAxios.post(`sponsor/old/system/payments`, data);
  return response?.data?.result;
};

export const getUnsponsoredOrphans = createAsyncThunk<
  any,
  {
    limit: number;
    page: number;
    beneficiary_type?: any;
    health_state_id?: any;
    sponsorship_type?: any;
  } // or number, depending on your data
>("sponsor/getUnsponsoredOrphans", async (payload) => {
  try {
    const response = await CAxios.post("sponsor/unsponsored_orphans", payload);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

export const getHealthStates = createAsyncThunk<AxiosResponse<any, any>>(
  "sponsor/getHealthStates",
  async () => {
    try {
      const response = await axios.get(
        `${baseUrlApi}beneficiary/health/states`
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);
// get SponsorShip amounts
export const getSponsorshipAmounts = createAsyncThunk(
  "sponsor/getSponsorshipAmounts",
  async () => {
    try {
      const response = await CAxios.get(`sponsorship`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

//Requests Types
export const getRequestsTypes = createAsyncThunk(
  "sponsor/get-requests-types",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}sponsor/requests/types`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

//Get All Sponsor Requests
export const getAllSponsorRequests = createAsyncThunk<
  any,
  { sponsor_id: number }
>("sponsor/get-all-sponsor-requests", async (payload) => {
  try {
    const response = await CAxios.post(`sponsor/requests/details`, payload);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});
//Add Sponsor Request
export const addRequest = createAsyncThunk<AxiosResponse<any, any>, any>(
  "sponsor/add-request",
  async (sponsorRequest) => {
    try {
      const response = await CAxios.post(`sponsor/requests`, sponsorRequest);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const getSponsorPaymentReport = createAsyncThunk<
  AxiosResponse<any, any>,
  any
>("sponsor/getSponsorPaymentReport", async (id) => {
  try {
    let response = await CAxios.get(`/payment/print/${id}`, {
      responseType: "blob" as const,
    });
    return response;
  } catch (error) {
    throw error;
  }
});
/*--------------------------Booking Request----------------------------- */
export const toAddBooking = createAsyncThunk<AxiosResponse<any, any>, any>(
  "sponsor/add-booking",
  async (data) => {
    try {
      const response = await CAxios.post(`booking`, data);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

// to edit sponsor profile
export const toEditSponsor = createAsyncThunk<AxiosResponse<any, any>, any>(
  "sponsor/details/edit",
  async (EditInfos) => {
    try {
      const response = await CAxios.post(`profile/details/edit`, EditInfos);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
export const getAllSponsorBooking = createAsyncThunk<
  any,
  { sponsor_id: number }
>("sponsor/getAllSponsorBooking", async (sponsor_id) => {
  try {
    const response = await CAxios.post(`sponsor/booking`, sponsor_id);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});
// same endpoint as getAllSponsorBooking, but not handled by the slice so it
// doesn't toggle sponsor.loading (which unmounts the booking list)
export const checkSponsorBooking = createAsyncThunk<
  any,
  { sponsor_id: number }
>("sponsor/checkSponsorBooking", async (sponsor_id) => {
  try {
    const response = await CAxios.post(`sponsor/booking`, sponsor_id);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});
/*--------------------------GET SPONSORED ORPHANS-------------------------------------------*/
export const getSponsoredOrphans = createAsyncThunk<
  any,
  { sponsor_id: number; limit?: number; page?: number; sponsorship_type?: any }
>("sponsor/getSponsoredOrphans", async (data) => {
  try {
    let response = await CAxios.post(`sponsor/sponsored_orphans`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});
/*--------------------------GET ENDOWMENT-------------------------------------------*/
export const getEndowment = createAsyncThunk<AxiosResponse<any, any>>(
  "sponsor/getEndowment",
  async () => {
    try {
      let response = await CAxios.get(`endowment`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
/*--------------------------GET ENDOWMENT TYPES-------------------------------------------*/
export const getEndowmentTypes = createAsyncThunk<AxiosResponse<any, any>>(
  "sponsor/getEndowmentTypes",
  async () => {
    try {
      let response = await axios.get(`${baseUrlApi}endowment/types`);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
/*--------------------------GET SPONSORED ORPHANS WITH PAGINATION-------------------------------------------*/
export const getSponsoredOrphansWithPagination = createAsyncThunk<
  any,
  { sponsor_id: number; limit?: number; page?: number; sponsorship_type?: any }
>("sponsor/getSponsoredOrphansWithPagination", async (data) => {
  try {
    let response = await CAxios.post(`sponsor/sponsored_orphans`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});

/*---------------------------GET ORPHANS NEEDS -----------------------------------------*/
export const getOrphansNeeds = createAsyncThunk<
  any,
  { sponsor_id: number; limit?: number; page?: number }
>("sponsor/getOrphansNeeds", async (data) => {
  try {
    const response = await CAxios.post(`sponsor/orphans/needs`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});
/*---------------------------GET MY ORPHANS NEEDS -----------------------------------------*/
export const getMyOrphansNeeds = createAsyncThunk<
  any,
  { sponsor_id: number; limit?: number; page?: number }
>("sponsor/getMyOrphansNeeds", async (data) => {
  try {
    const response = await CAxios.post(`sponsor/my/orphans/needs`, data);
    return response?.data?.result;
  } catch (error) {
    throw error;
  }
});
